/**
 * Shopify Dawn Product Customization
 * ----------------------------------
 * Vanilla JS
 * Compatible with Dawn
 */

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".product-customization-block").forEach(initCustomization);
});

function initCustomization(wrapper) {
  const typeSelect = wrapper.querySelector("[data-customization-type]");
  const textWrapper = wrapper.querySelector("[data-text-wrapper]");
  const imageWrapper = wrapper.querySelector("[data-image-wrapper]");

  const textInput = wrapper.querySelector("#custom-text");
  const fontSelect = wrapper.querySelector("#font-family-select");

  const imageInput = wrapper.querySelector("#custom-image");
  const fileName = wrapper.querySelector("#selected-file-name");

  const errorBox = wrapper.querySelector(".product-customization-error");

  if (!typeSelect) return;

  //------------------------------------------------
  // Initial State
  //------------------------------------------------

  hide(textWrapper);
  hide(imageWrapper);

  //------------------------------------------------
  // Type Change
  //------------------------------------------------

  typeSelect.addEventListener("change", function () {
    clearErrors();

    switch (this.value) {
      case "Text":
        show(textWrapper);
        hide(imageWrapper);

        if (imageInput) {
          imageInput.value = "";
          if (fileName) fileName.textContent = "";
        }

        break;

      case "Image":
        show(imageWrapper);
        hide(textWrapper);

        if (textInput) textInput.value = "";
        if (fontSelect) fontSelect.selectedIndex = 0;

        break;

      default:
        hide(textWrapper);
        hide(imageWrapper);

        if (textInput) textInput.value = "";
        if (fontSelect) fontSelect.selectedIndex = 0;

        if (imageInput) imageInput.value = "";
        if (fileName) fileName.textContent = "";
    }
  });

  //------------------------------------------------
  // Font Preview
  //------------------------------------------------

  if (fontSelect && textInput) {
    fontSelect.addEventListener("change", function () {
      textInput.style.fontFamily = this.value || "";
    });
  }

  //------------------------------------------------
  // File Upload
  //------------------------------------------------

  if (imageInput) {
    imageInput.addEventListener("change", function () {
      clearErrors();

      if (!this.files.length) {
        fileName.textContent = "";
        return;
      }

      const file = this.files[0];

      if (file.size > 10 * 1024 * 1024) {
        showError("Maximum file size is 10MB.");
        this.value = "";
        fileName.textContent = "";
        return;
      }

      fileName.textContent = file.name;
    });
  }

  //------------------------------------------------
  // Validation
  //------------------------------------------------

  const form = wrapper.closest("product-form");

  if (!form) return;

  const productForm = form.querySelector("form");

  if (!productForm) return;

  productForm.addEventListener("submit", function (e) {

    clearErrors();

    const type = typeSelect.value;

    if (!type) {
      e.preventDefault();
      showError("Please select a customization type.");
      return;
    }

    if (type === "Text") {

      if (!textInput.value.trim()) {
        e.preventDefault();
        showError("Please enter your text.");
        textInput.focus();
        return;
      }

      if (fontSelect && !fontSelect.value) {
        e.preventDefault();
        showError("Please select a font.");
        fontSelect.focus();
        return;
      }

    }

    if (type === "Image") {

      if (!imageInput.files.length) {
        e.preventDefault();
        showError("Please upload an image.");
        imageInput.focus();
        return;
      }

    }

  });

  //------------------------------------------------
  // Helpers
  //------------------------------------------------

  function show(element) {
    if (element) element.hidden = false;
  }

  function hide(element) {
    if (element) element.hidden = true;
  }

  function clearErrors() {
    if (!errorBox) return;

    errorBox.hidden = true;
    errorBox.textContent = "";
  }

  function showError(message) {
    if (!errorBox) return;

    errorBox.hidden = false;
    errorBox.textContent = message;
  }

}